module.exports = __webpack_public_path__ + "static/media/icon-collection-selected-green.814752a3.svg";